import { io } from 'socket.io-client';

// O socket conecta no host da API (sem o sufixo /api). Em dev, :3020.
const SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL ||
  (import.meta.env.VITE_API_URL ? import.meta.env.VITE_API_URL.replace(/\/api\/?$/, '') : '') ||
  'http://localhost:3020';

let socket = null;

/** Conecta (lazy) com o JWT salvo. Reaproveita a mesma conexão. */
export function getSocket() {
  if (socket) return socket;
  const token = localStorage.getItem('movez_token');
  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect: true,
  });
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
